import {
  GET_POSITION,
  GET_STRUCTURE,
  GET_POSITION_SUCCESS,
  GET_POSITION_FAIL,
  DELETE_POSITION,
  DELETE_POSITION_SUCCESS,
  DELETE_POSITION_FAIL,
  UPDATE_POSITION,
  UPDATE_POSITION_SUCCESS,
  UPDATE_POSITION_FAIL,
  ADD_NEW_POSITION,
  ADD_POSITION_SUCCESS,
  ADD_POSITION_FAIL,
  POSITION_LOADING,
  POSITION_RESET
} from "./actionType";

export const resetPositionState = (actionType) => ({
  type: POSITION_RESET,
  payload: { actionType },
});

export const getPositionSuccess = (actionType, data) => ({
  type: GET_POSITION_SUCCESS,
  payload: { actionType, data },
});

export const getPositionFail = (actionType, error) => ({
  type: GET_POSITION_FAIL,
  payload: { actionType, error },
});

export const getPosition = (data, path) => ({
  type: GET_POSITION,
  payload: data, path
});

export const getStructure = (data, path) => ({
  type: GET_STRUCTURE,
  payload: data, path
});

export const getPositionLoading = () => ({
  type: POSITION_LOADING
});

export const deletePosition = data => ({
  type: DELETE_POSITION,
  payload: data,
});

export const deletePositionSuccess = data => ({
  type: DELETE_POSITION_SUCCESS,
  payload: data,
});

export const deletePositionFail = error => ({
  type: DELETE_POSITION_FAIL,
  payload: error,
});

export const updatePosition = data => ({
  type: UPDATE_POSITION,
  payload: data,
});

export const updatePositionFail = error => ({
  type: UPDATE_POSITION_FAIL,
  payload: error,
});

export const updatePositionSuccess = data => ({
  type: UPDATE_POSITION_SUCCESS,
  payload: data,
});

export const addNewPosition = data => ({
  type: ADD_NEW_POSITION,
  payload: data,
});

export const addPositionSuccess = data => ({
  type: ADD_POSITION_SUCCESS,
  payload: data,
});

export const addPositionFail = error => ({
  type: ADD_POSITION_FAIL,
  payload: error,
});